import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDiscountRepository } from '../../repositories/interfaces/iDiscountRepository';
import { CSRFTokenRequest } from '../../../entity';
export interface IReSubscribeViaGiftCardUseCase {
    execute(
        username: string,
        tierGuid: string,
        discountCode: string,
        token: string,
        identityToken: string,
        authSign: string,
        authToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<boolean>;
}

export class ReSubscribeViaGiftCardUseCase implements IReSubscribeViaGiftCardUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get reSubViaGiftCard(): IDiscountRepository {
        return container.resolve<IDiscountRepository>(DI.REPOSITORIES.IDiscountRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        tierGuid: string,
        discountCode: string,
        token: string,
        identityToken: string,
        authSign: string,
        authToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<boolean> {
        const response = await this.reSubViaGiftCard.reSubscribeViaGiftCard(
            username,
            tierGuid,
            discountCode,
            token,
            identityToken,
            authSign,
            authToken,
            csrfToken
        );
        // if (response.data.tierGuid === tierGuid) {
        //     return true;
        // }
        return false;
    }
}
